import React, {useState, useEffect, useMemo, useCallback, useRef} from "react";
import PromoBanner from "../promoBanner.js";
import MediaFormModal from './profile/MediaForm.js';
import "../CryptoPage.css";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import {getAlertCountAPI, getTop7DayPerformerAPI, updateAccount} from "../../apihelper/profile";
import UserAvatar from "../userAvatar.js";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import TransactionCard2 from "./reward_trasaction_history/TransactionCard2.jsx";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {BottomNavigation, CircularProgress} from "@mui/material";
import {tabLink} from "../../common/constant/tablink.jsx";
import BottomTab from "../../common/hooks/BottomTab.jsx";
import IconButton from "@mui/material/IconButton";
import {Grid} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import {useLocation, Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import {getUserRewardList} from "../../apihelper/portfolio";

import EmailPopUp from "../EmailPopUp.js";
import SidebarMenuList from "../../includes/sidebarMenuList.jsx";
import TabHook from "../../common/hooks/TabHook.jsx";
import LoginPopUp from "../../common/alert/login/LoginPopUp.jsx";
import { ElectricScooterRounded } from "@mui/icons-material";

const RewardSection = (props) => {
    const {window1} = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const [rewards, setRewards] = useState([]);
    const [loading, setLoading] = useState(false);
    const userData = useMemo(() => JSON.parse(localStorage.getItem("cw_portfolio_user")), []);
    const drawerWidth = 292;
    const [page, setPage] = useState(0);
    const limit = 10;

    const [dataCompleted, setDataCompleted] = useState(false);
    const tableBodyRef = useRef(null);
    const lastRowRef = useRef(null);
    const [unreadAlerts, setUnreadAlerts] = useState(0);
    const [showModal, setShowModal] = useState(false);
     useEffect(() => {
            const userId = userData?.user_id || null;
    
            const fetchAlertsCount = async () => {
                try {
                    const formData = new URLSearchParams();
                    formData.append("user_id", userId); // convert to form-encoded format
    
                    const response = await fetch("https://crowdwisdom.live/wp-json/api/v1/crypto_alerts_count", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded", // ✅ no preflight
                        },
                        body: formData, // ✅ correct format for this content type
                    });
    
                    if (!response.ok) {
                        throw new Error(`Error: ${response.status}`);
                    }
    
                    const data = await response.json();
                    console.log(data);
                    setUnreadAlerts(data.unread_notifications);
                } catch (error) {
                    console.error("Failed to fetch alerts:", error);
                }
            };
    
            fetchAlertsCount();
        }, []);
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const container = window1 ? window1().document.body : undefined;

    const getIcon = useMemo(
        () => (path, activeIcon, inactiveIcon) => location.pathname === path ? activeIcon : inactiveIcon,
        [location.pathname]
    );

    const fetchUserRewards = useCallback(async () => {
    console.log("Calling Fetch user rewards");
    if (loading || dataCompleted) return;
    const startIndex = page * limit;

    setLoading(true);
    try {
        if (!userData) {
            console.log("No User Id is recorded");

            // Set default rewards
            const defaultRewards = [
                {
                    id: "N/A",
                    user_id: "N/A",
                    created_at: "N/A",
                    action: "Make an Account",
                    status: "Incomplete",
                    login_count: 0,
                    reward_tokens: "1000"
                },
                {
                    id: "N/A",
                    user_id: "N/A",
                    created_at: "N/A",
                    action: "Make a Portfolio",
                    status: "Incomplete",
                    login_count: 0,
                    reward_tokens: "1000"
                },
                {
                    id: "N/A",
                    user_id: "N/A",
                    created_at: "N/A",
                    action: "Login to platform 10 times in a month",
                    status: "Incomplete",
                    login_count: 0,
                    reward_tokens: "2000"
                },
                 {
                    id: "N/A",
                    user_id: "N/A",
                    created_at: "N/A",
                    action: "Join our TG Channel",
                    status: "Incomplete",
                    login_count: 0,
                    reward_tokens: "1000"
                },
                 {
                    id: "N/A",
                    user_id: "N/A",
                    created_at: "N/A",
                    action: "Join Twitter",
                    status: "Incomplete",
                    login_count: 0,
                    reward_tokens: "1000"
                }
            ];

            setRewards(defaultRewards);
            setDataCompleted(true); // stop further fetching
        } else {
            const data = await getUserRewardList(userData, startIndex, limit);
            console.log("Rewards Data: ", data);
             setLoginCount(data.login_count);

            if (data.length < limit) {
                setDataCompleted(true);
            }

            setPage(page + 1);
            setRewards((prevRewards) => [...prevRewards, ...data]);
        }
    } catch (error) {
        console.error("Failed to fetch rewards", error);
    } finally {
        setLoading(false);
    }
}, [userData, loading, dataCompleted, page, limit]);


    useEffect(() => {
        fetchUserRewards();
    }, [fetchUserRewards]);

    const handleModalClose = useCallback(() => {
        setLoginModalOpen(false);
        navigate(location.pathname, {replace: true});
    }, [navigate, location.pathname]);

    const handleDrawerToggle = useCallback(() => {
        setMobileOpen((prev) => !prev);
    }, []);

    const handleSubscriptionClick = () => {
        if (userData) {
            navigate("/subscriptions");
        } else {
            const originalUrl = "/subscriptions";
            sessionStorage.setItem("originalUrl", originalUrl);
            handleLoginClick();
        }
    };

    const handleLoginClick = () => {
        const originalUrl = "/reward-section";
        sessionStorage.setItem("originalUrl", originalUrl);
        window.history.pushState({}, "", "/login");
        localStorage.setItem("isPopupManuallyOpened", "true");
        setLoginModalOpen(true);
    };

    const handleIntersection = (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !dataCompleted) {
            fetchUserRewards(); // Trigger the API call when the last row is in the viewport
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, {
            root: tableBodyRef.current,
            rootMargin: "0px",
            threshold: 1.0,
        });

        if (lastRowRef.current) {
            observer.observe(lastRowRef.current);
        }

        // Cleanup the observer when the component unmounts
        return () => {
            if (lastRowRef.current) {
                observer.unobserve(lastRowRef.current);
            }
        };
    }, [handleIntersection]);

      const [path, setPath] = useState("/");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active? "5px 10px" : "4px 4px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight:  "600", 
            fontSize: "15px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                        fontSize: "14px",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            backgroundColor: "#1877F2",
                            padding: "5px 4px",
                            borderRadius: "50px",
                            fontSize: "14px",
                        }}
                    >
                        {[tabLink["rewards"], tabLink["portfolio_audit"], tabLink["screener"]].map(
                            (tab, index) => (
                                <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window?.constants?.asset_path + tab.icon}
                                            alt="icon"
                                            style={{
                                                marginRight: "4px",
                                                height: tab.icon_width || "25px",
                                                filter: iconFilter(isActive(tab.href)),
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>

                                    {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "5px",
                        marginTop: "0px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>

                <div style={{display:"flex",alignItems:"center", justifyContent:"flex-end",gap:"5px",marginRight:"15px"}}>

                    {/* Notification Bell */}
                    <div
                        onClick={() => (window.location.href = "/alerts")}
                        style={{position: "relative", cursor: "pointer"}}
                    >
                        <NotificationIcon className="notification-icon fa-2x" />
                         {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                    </div>

                     <UserAvatar/>
            </div>
                 
</div>


            </div>
        );
    };
    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "3px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "12px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["rewards"], tabLink["screener"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height:  "20px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                               {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                       <UserAvatar/>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    const SkeletonLoader = () => (
     <>
       {Array.from({ length: 6 }).map((_, index) => (
         <tr key={index} style={{ background: "#fff", border: "1px solid #1877F2", borderRadius: "10px", marginBottom: "10px", padding: "6px", height: "60px" }}>
           {Array.from({ length: 6 }).map((_, idx) => (
             <td
               key={idx}
               style={{
                 padding: "12px",
                 textAlign: "center",
                 fontSize: "14px",
                 border: "1px solid #1877F2",
                 borderRadius: idx === 0 ? "20px 0 0 20px" : idx === 5 ? "0 20px 20px 0" : "0",
                 borderLeft: idx === 0 ? "none" : "",
                 borderRight: idx === 4 ? "none" : "",
               }}
             >
               <div className="skeleton-box" />
             </td>
           ))}
         </tr>
       ))}
     </>
   );

   const [fullName, setFullName] = React.useState("");
   const [profilePhoto, setProfilePhoto] = React.useState();
   const [description, setDescription] = React.useState("");
   const [isSaved, setIsSaved] = React.useState(false);
   const [youtubeLink, setYoutubeLink] = React.useState("");
   const [twitterLink, setTwitterLink] = React.useState("");
   const [telegramLink, setTelegramLink] = React.useState("");
   const [instagramLink, setInstagramLink] = React.useState("");

   const [walletAddress, setWalletAddress] = React.useState("");
   const [copied, setCopied] = React.useState(false);
   const generateReferralLink = () => {
        const formattedFullName = fullName.replace(/\s+/g, "-");
        return `https://investing.crowdwisdom.live/signUp?ref=${formattedFullName}`;
    };
   const handleInputChange = (e) => {
         if (!userData) {
            handleLoginClick(); // Trigger login if not logged in
            return; // Exit early to avoid setting state
        }
        setWalletAddress(e.target.value);
        setIsSaved(false);
    };
   const handleSave = () => {
            if (walletAddress) {
                const user_id = userData.user_id;
                const token = userData.token;

                updateAccount({
                    user_id: user_id,
                    fullName,
                    profilePhoto,
                    about: description,
                    youtube: youtubeLink,
                    twitter: twitterLink,
                    telegram: telegramLink,
                    instagram: instagramLink,
                    wallet_address: walletAddress,
                    token: token,
                }).then((res) => {
                    if (res.code === "200") {
                        userData.full_name = fullName;
                        userData.wallet_address = walletAddress;

                        setFullName(res.data.full_name);
                        setDescription(res.data.description);
                        setTwitterLink(res.data.twitter_link);
                        setProfilePhoto(res.data.photo);
                        setWalletAddress(res.data.wallet_address);
                    } else {
                        alert(res.message);
                    }
                });
                setIsSaved(true);
            }
        };

  const expectedActions = [
  "Make an Account",
  "Make a Portfolio",
  "Login to platform 10 times in a month",
  "Join Our TG Channel",
  "Join Twitter",
];

const staticRewards = {
  "Make an Account": 1000,
  "Make a Portfolio": 1000,
  "Login to platform 10 times in a month": 2000,
  "Join Our TG Channel": 1000,
  "Join Twitter": 1000,
};

const [finalRewards, setFinalRewards] = useState([]);

useEffect(() => {
  const updatedFinalRewards = expectedActions.map((action) => {
    const found = rewards.find((r) => r.action === action);

    let reward_tokens = staticRewards[action];
    let status = "Incomplete";

    if (found) {
      if (found.status === "Complete") {
        reward_tokens = 0;
        status = "Complete";
      } else {
        reward_tokens += parseInt(found.reward_tokens || 0);
        status = "Incomplete";
      }
    }

    return {
      id: found?.id || "na",
      user_id: found?.user_id || "na",
      reward_tokens: reward_tokens.toString(),
      created_at: found?.created_at || "NA",
      action,
      status,
      login_count: found?.login_count ?? 0,
    };
  });

  setFinalRewards(updatedFinalRewards);
}, [rewards]);


    const [loginCount, setLoginCount] = useState(0);
    const handleCheckInClick = async (data) => {
            if (!userData) {
            handleLoginClick(); // redirect/login modal if not logged in
            return;
            }
          setLoginCount(data.login_count); // update button label
            
        };
        
    const getButtonLabel = (data) => {
        if (data.action === "Make a Portfolio") {
             if(!userData)
                 return "Make Portfolio";
             else{
                if(data.status =='Complete') return 'Portfolio Made';
                else return 'Make a Portfolio';
             }
        }
            
           
        if (data.action === "Make an Account") {
            if(!userData)
            return "Start Login";
            else
            return "Logged in";

        }

        if (data.action === "Join Our TG Channel"){
             if(!userData)
           return "Join Channel";
             else{
                if(data.status =='Complete') return 'Joined';
                else return 'Join Channel';
             }
        } 
        if (data.action === "Join Twitter") {
            if(!userData)
           return "Join Channel";
             else{
                if(data.status =='Complete') return 'Joined';
                else return 'Join Channel';
             }
        }
          if (data.action === "Login to platform 10 times in a month") {
            if (!userData) return "Check in Now";
            return data.status=="Complete"
            ?  "10/10 Completed"
            : `${data.login_count} Logins in last 30 days`; // count only after click
        }

        return "Participate";
    };

    const handleClick = (data) => {
        if (data.action === "Make a Portfolio") {
        window.location.href = "https://investing.crowdwisdom.live/audit-my-portfolio";
        } else if (data.action === "Make an Account" || data.action === "Start Login") {
        handleLoginClick();
        } else if (data.action === "Login to platform 10 times in a month") {
       handleCheckInClick(data); 
        }
        else if (data.action === "Join Our TG Channel") {
            if(!userData)  handleLoginClick();
            else setShowModal(true); 
        }
         else if (data.action === "Join Twitter") {
            if(!userData)  handleLoginClick();
            else setShowModal(true); 
        }
    };



    return (
        <div
            className="crypto-page"
            style={{
                padding: mediaQueryVar ? 0 : "10px",
                margin: 0,
                backgroundColor:  "#fff",
                height: "100vh",
                paddingTop:mediaQueryVar? "180px":"200px",
            }}
        >
              {showModal && <MediaFormModal onClose={() => setShowModal(false)} />}
            <Helmet>
                <title>Transaction History</title>
            </Helmet>
            {mediaQueryVar ? (
                <div className="layout">
                                          <div
                                                style={{
                                                    position: "fixed",
                                                    top: 0,
                                                    left: drawerWidth,
                                                    width: `calc(100% - ${drawerWidth}px)`,
                                                    backgroundColor: "#ffffff",
                                                    zIndex: 1000,
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                    height: "100px", // You may need to increase this if banner + nav exceeds 100px
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <PromoBanner />
                                                <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                                          </div>
                    <Box
                        component="nav"
                        sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                        aria-label="mailbox folders"
                    >
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{keepMounted: true}}
                            sx={{
                                display: {xs: "block", sm: "none"},
                                "& .MuiDrawer-paper": {
                                    boxSizing: "border-box",
                                    width: drawerWidth,
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                        >
                            <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
                                <SidebarMenuList />
                            </div>
                        </Drawer>
                        <Drawer
                            variant="permanent"
                            sx={{
                                display: {xs: "none", sm: "block"},
                                "& .MuiDrawer-paper": {
                                    boxSizing: "border-box",
                                    width: drawerWidth,
                                    backgroundColor: "white",
                                    color: "#727376",
                                },
                            }}
                            open
                        >
                            <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
                                <SidebarMenuList />
                            </div>
                        </Drawer>
                    </Box>

                    <div className="content" style={{margin: "0%", padding: "10px", marginTop: "0px"}}>
                        
                        <div
                            style={{
                                padding: "15px",
                                fontFamily: "Satoshi, sans-serif",
                                margin: "0px 5px",
                            }}
                        >

                            <div className="input-container row mt-0 order-2  order-md-2">
                            <div className="address-input col-12 col-md-6 mb-3">
                                <input
                                    style={{
                                        paddingRight: "58px",
                                    }}
                                    type="text"
                                    id="userInput"
                                    placeholder="Enter Your Solana Wallet Address"
                                    value={walletAddress}
                                    onChange={handleInputChange}
                                />
                                <button onClick={handleSave}>Save</button>
                            </div>
                            <div className="address-input col-12 col-md-6 mb-3">
                                <input
                                    style={{
                                        paddingRight: copied ? "70px" : "63px",
                                    }}
                                    type="text"
                                    placeholder="Your Referral Link"
                                    value={generateReferralLink()}
                                    readOnly
                                    onFocus={(e) => (e.target.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)")}
                                    onBlur={(e) => (e.target.style.boxShadow = "0px 2px 6px rgba(0, 0, 0, 0.1)")}
                                />
                                <button
                                    onClick={() => {
                                        navigator.clipboard.writeText(generateReferralLink());
                                        setCopied(true);
                                        setTimeout(() => setCopied(false), 2000);
                                        console.log("calling");
                                    }}
                                    onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                                    onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                >
                                    {copied ? "Copied!" : "Copy"}
                                </button>
                            </div>
                            <div className="address-input col-12 col-md-6 mb-3">
                                <input
                                    style={{
                                        paddingRight: "58px",
                                    }}
                                    type="text"
                                    placeholder="Your TG Address For Farming"
                                />
                                <button>Save</button>
                            </div>
                           </div>
                         {/* Rewards Section */}
                        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between text-center text-md-start mb-5 mt-5 reward-container">
                            {/* Transaction Card - Moves below Airdrop in mobile */}
                            <div className="w-100">
                                <TransactionCard2 />
                            </div>

                         
                        </div>
                           

                            <div style={{width: "100%", overflowX: "auto"}}>
                <table
                 style={{
                   width: "100%",
                   borderCollapse: "separate",
                   borderSpacing: "0 12px",
                   minWidth: "100%", 
                   tableLayout: "fixed",
                   }}
                 >
               <thead>
               <tr
               style={{
               background: "linear-gradient(to right, #eef6ff, #d6eaff)",
               color: "#000",
               fontWeight: "bold",
               fontSize: "14px",
               textAlign: "left",
               }}
               >
               <th style={{ padding: "12px 16px", borderRadius: "10px 0 0 10px", width: "40%", fontWeight:"bold" }}>Stage</th>
               <th style={{ padding: "12px", textAlign: "center", width: "18%",fontWeight:"bold" }}>Potential Earnings</th>
               <th style={{ padding: "12px", textAlign: "center", width: "17%",fontWeight:"bold" }}>Status</th>
               <th style={{ padding: "12px", textAlign: "center", width: "25%",fontWeight:"bold" }}>Action</th>
               </tr>
               
               </thead>
                <tr>
    <td colSpan={4}>
      <div style={{ width: "100%", height: "4px", background: "#1877F2" }}></div>
    </td>
  </tr>
   
               <tbody>
               {loading  ? <SkeletonLoader /> : 
              finalRewards?.length === 0  ? (
                 <tr>
                 <td colSpan="6" style={{
                   textAlign: "center",
                   padding: "20px",
                   fontSize: "16px",
                   fontWeight: "bold",
                   border: "2px solid #1877F2",
                   borderRadius: "10px",
                   background: "#f8f9fa",
                   color: "#1877F2"
                 }}>
                  No Reward Transaction Available
                 </td>
               </tr>
               ):(
               finalRewards.map((data, index) => (
               <tr
               key={index}
               style={{
                 background: "#fff",
                 border: "1px solid #1877F2",
                 borderRadius: "10px",
                 marginBottom: "10px",
                 padding: "3px 6px",
                 height: "60px",
               }}
               >
               <td
               style={{ padding: "10px 12px", textAlign: "center", fontSize: "14px",border: "1px solid #1877F2",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px", borderRight:"none" }}>
                 <div style={{
                   padding: "10px",
                   display: "flex",
                   alignItems: "center",
                   fontWeight: "bold",
                   fontSize: "15px",
                   color: "#000",
                   borderRadius: "10px",
                   minWidth: "120px",
                   background: "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                   boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                 }}
               >
               {data.action || "N/A"}

                    </div>
               </td>
   
               <td style={{ padding: "12px", textAlign: "center", fontSize: "14px",border: "1px solid #1877F2",borderLeft:"none", borderRight:"none", fontWeight:"600" }}> {data.reward_tokens ?? "0"}</td>
   
               <td style={{ padding: "12px", textAlign: "center", fontSize: "14px",border: "1px solid #1877F2",borderLeft:"none", borderRight:"none"  }}> 
                                <span style={{
                                background: data.status === "Complete" ? "rgba(0, 128, 0, 0.82)" : "rgba(255, 18, 18, 0.82)",
                                color: "white",
                                border: "1px solid #1877F2",
                                borderRadius: "16px",
                                padding: "12px 15px",
                                minWidth:"150px",
                                width:"150px",
                                minHeight:"55px",
                                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                                }}>
                                {data.status === "Complete" ? "Completed" : "Incomplete"}
                                </span>
 
                </td>
   
               <td style={{
                    padding: "12px",
                    textAlign: "center",
                    fontSize: "14px",
                    border: "1px solid #1877F2",
                    borderTopRightRadius: "20px",
                    borderBottomRightRadius: "20px",
                    borderLeft: "none"
                    }}>
                    <span
                        style={{
                        background: "white",
                        color: "#000",
                        border: "1px solid #1877F2",
                        borderRadius: "16px",
                        padding: "12px 15px",
                        minWidth: "150px",
                        width: "150px",
                        minHeight: "55px",
                        fontWeight: "bold",
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                        cursor:
                        (["Make a Portfolio", "Make an Account", "Login to platform 10 times in a month","Join Our TG Channel", "Join Twitter"].includes(data.action) && data.status === "Complete")
                            ? "default"
                            : "pointer"
                        }}
                        onClick={
                            (["Make a Portfolio", "Make an Account", "Login to platform 10 times in a month","Join Our TG Channel", "Join Twitter"].includes(data.action) && data.status === "Complete")
                                ? undefined
                                : () => handleClick(data)
                        }
                    >
                        {getButtonLabel(data)}
                    </span>
                    </td>


   
            
               </tr>
               
                
               ))
               
   
               )}
                <tr ref={lastRowRef} style={{visibility: "hidden"}}></tr>
               </tbody>
            </table>
                                
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <Grid item xs={12} align="left" sx={{marginBottom: "10%"}}>
                                    <div
                                        style={{
                                            position: "fixed",
                                            top: 0,
                                            left: 0, // aligns it to the right of the sidebar
                                            width: "100%", // takes full width minus sidebar
                                            backgroundColor: "#ffffff",
                                            zIndex: 1000,
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            height: "100px",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <PromoBanner />
                                        <TopNavigationMobile unreadAlerts={unreadAlerts} />
                                    </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin:"10px auto",
                                fontSize: "20px",
                                minWidth:"100%"
                            }}
                        >
                          <Typography style={{
                            fontSize: "20px", 
                            fontWeight: "700",
                            background: "linear-gradient(91.4deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                            border:"1px solid #1877F2",
                            padding:"6px 15px",
                            borderRadius:"8px",
                            color:"#1877F2"
                            }}>
                               Farming Activities
                            </Typography>

                           
                        </div>
                    </Grid>

                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{keepMounted: true}}
                        sx={{
                            display: {xs: "block", sm: "none"},
                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: {drawerWidth},
                                backgroundColor: "white",
                                color: "#727376",
                            },
                        }}
                    >
                        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
                            <SidebarMenuList />
                        </div>
                    </Drawer>
                   
                  

            <div>
                                          <div
                                                className="input-container row mt-3 order-2  order-md-2 "
                                                style={{marginRight: mediaQueryVar ? "15px" : ""}}
                                            >
                                                <div className="address-input col-12 col-md-6 mb-3">
                                                    <input
                                                        style={{
                                                            paddingRight: "58px",
                                                        }}
                                                        type="text"
                                                        id="userInput"
                                                        placeholder="Enter Your Solana Wallet Address"
                                                        value={walletAddress}
                                                        onChange={handleInputChange}
                                                    />
                                                    <button onClick={handleSave}>Save</button>
                                                </div>
                                                <div className="address-input col-12 col-md-6 mb-3">
                                                    <input
                                                        style={{
                                                            paddingRight: copied ? "70px" : "63px",
                                                        }}
                                                        type="text"
                                                        placeholder="Your Referral Link"
                                                        value={generateReferralLink()}
                                                        readOnly
                                                        onFocus={(e) => (e.target.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)")}
                                                        onBlur={(e) => (e.target.style.boxShadow = "0px 2px 6px rgba(0, 0, 0, 0.1)")}
                                                    />
                                                    <button
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(generateReferralLink());
                                                            setCopied(true);
                                                            setTimeout(() => setCopied(false), 2000);
                                                        }}
                                                        onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                                                        onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                                    >
                                                        {copied ? "Copied!" : "Copy"}
                                                    </button>
                                                </div>
                                                <div className="address-input col-12 col-md-6 mb-3">
                                                    <input
                                                        style={{
                                                            paddingRight: "58px",
                                                        }}
                                                        type="text"
                                                        placeholder="Your TG Address For Farming"
                                                    />
                                                    <button>Save</button>
                                                </div>
                                            </div>
                
                                            {/* Rewards Section */}
                                            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between text-center text-md-start mb-4 mt-2 reward-container">
                                                {/* Transaction Card - Moves below Airdrop in mobile */}
                                                <div className="w-100">
                                                    <TransactionCard2 />
                                                </div>
                
                                               
                                            </div>

            {loading ? (
           // Skeleton Loader (5 placeholder cards)
           Array.from({ length: 5 }).map((_, index) => (
             <div
               key={index}
               style={{
                 background: "white",
                 borderRadius: "12px",
                 boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                 marginBottom: "15px",
                 padding: "0px",
                 border: "1px solid #1877F2",
                 position: "relative",
                 overflow: "hidden",
               }}
             >
               {/* Shimmer effect */}
               <div
                 style={{
                   position: "absolute",
                   top: 0,
                   left: 0,
                   width: "100%",
                   height: "100%",
                   background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)",
                   animation: "shimmer 1.5s infinite",
                 }}
               ></div>
   
               {/* Placeholder Content */}
               <div
                 style={{
                   display: "flex",
                   alignItems: "center",
                   fontWeight: "bold",
                   fontSize: "16px",
                   color: "#333",
                   background: "var(--try-gradient, linear-gradient(90deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0.00) 123.27%))",
                   borderRadius: "28px",
                   padding: "10px",
                 }}
               >
                 <div
                   style={{
                     width: "28px",
                     height: "28px",
                     borderRadius: "50%",
                     background: "#e0e0e0",
                     marginRight: "10px",
                   }}
                 ></div>
                 <div
                   style={{
                     width: "100px",
                     height: "16px",
                     background: "#e0e0e0",
                     borderRadius: "4px",
                   }}
                 ></div>
               </div>
   
               <div
                 style={{
                   width: "98%",
                   height: "2px",
                   background: "#1877F2",
                   marginBottom: "15px",
                   marginLeft: "auto",
                   marginRight: "auto",
                 }}
               ></div>
   
               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: "10px", fontSize: "14px", marginLeft: "10px" }}>
                 {Array.from({ length: 4 }).map((_, i) => (
                   <div key={i} style={{ display: "flex", justifyContent: "space-between", marginRight: "10px" }}>
                     <div
                       style={{
                         width: "80px",
                         height: "14px",
                         background: "#e0e0e0",
                         borderRadius: "4px",
                       }}
                     ></div>
                     <div
                       style={{
                         width: "50px",
                         height: "14px",
                         background: "#e0e0e0",
                         borderRadius: "4px",
                       }}
                     ></div>
                   </div>
                 ))}
               </div>
   
               <button
                 style={{
                   display: "block",
                   width: "90%",
                   margin: "15px auto",
                   padding: "10px",
                   fontSize: "14px",
                   fontWeight: "bold",
                   background: "#e0e0e0",
                   border: "none",
                   borderRadius: "20px",
                   textAlign: "center",
                   boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                 }}
               ></button>
             </div>
           ))
         ) : rewards.length === 0 ? (
           // No Data Message
           <div
             style={{
               textAlign: "center",
               padding: "20px",
               border: "2px solid #1877F2",
               borderRadius: "12px",
               color: "#1877F2",
               fontSize: "16px",
               fontWeight: "bold",
               background: "rgba(24, 119, 242, 0.1)",
             }}
           >
             No Reward Transaction Available
           </div>
         ) : (

          <div ref={lastRowRef} style={{ height: '100vh', overflowY: 'auto', paddingBottom:"100px" }}>
                             {finalRewards.map((data, index) => (
                             <div
                             key={index}
                             style={{
                               background: "white",
                               borderRadius: "12px",
                               boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                               marginBottom: "15px",
                               padding: "0px",
                               border: "1px solid #1877F2",
                             }}
                             >
                             {/* Crypto Name and Logo */}
                             <div style={{display:"flex",justifyContent:"space-between", marginBottom: "1px",alingItems:"center",
                                 background :"var(--try-gradient, linear-gradient(90deg, rgba(24, 119, 242, 0.17) 0.02%, rgba(24, 119, 242, 0.00) 123.27%))",
                                 borderRadius:"28px",
                                 padding: "10px"}}>
                             <div
                               style={{
                                 display: "flex",
                                 alignItems: "center",
                                 fontWeight: "bold",
                                 fontSize: "16px",
                                 color: "#000",
                                
                               }}
                             > {data.action || "N/A"} </div>

                              
                             </div>
                             <div style={{width:"98%",height:"2px",background:"#1877F2",marginBottom:"15px",marginLeft:"auto",marginRight:"auto"}}></div>
   
                             {/* Left-Right Two-Column Layout */}
                              
   
                               <div style={{ 
                                width:"180px",
                                height:"50px",
                                margin:"3px auto",
                                display: "flex", 
                                alignItems:"center",
                                justifyContent: "center" , 
                                borderRadius: "15px",
                                border: "1px solid #1877F2",
                                fontSize:"15px",
                                fontWeight:"700",
                                color:"black",
                                background: "var(--Grad, linear-gradient(180deg, rgba(24, 119, 242, 0.40) -1.89%, rgba(24, 119, 242, 0.00) 60.38%))"
                                }}>
                               Potential Earnings {data.reward_tokens ?? "0"}
                               </div>
   
                               
   
                            <div style={{
                                display:"flex",
                                alignitems:"center",
                                justifyContent:"space-between",
                                gap:"5px"
                            }}>
                             <button
                               style={{
                                 display: "block",
                                 margin: "15px auto",
                                 padding: "6px 18px",
                                 fontSize: "14px",
                                 fontWeight: "bold",
                                 background: data.status === "Complete" ? "rgba(0, 128, 0, 0.82)" : "rgba(255, 18, 18, 0.82)",
                                 border: "none",
                                 borderRadius: "30px",
                                 cursor: "pointer",
                                 textAlign: "center",
                                 boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                 color: "white",
                                 minWidth:"140px"
                               }}
                             >
                             {data.status === "Complete" ? "Completed" : "Incomplete"}
                             </button>
                             <button
                               style={{
                                 display: "block",
                                 margin: "15px auto",
                                 padding: "6px 18px",
                                 fontSize: "14px",
                                 fontWeight: "bold",
                                 background: "#fff",
                                 border: "2px solid #1877F2",
                                 borderRadius: "30px",
                               
                                 textAlign: "center",
                                 boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                                 color: "#000",
                                 minWidth:"140px",
                               cursor:
                        (["Make a Portfolio", "Make an Account", "Login to platform 10 times in a month","Join Our TG Channel", "Join Twitter"].includes(data.action) && data.status === "Complete")
                            ? "default"
                            : "pointer"
                        }}
                        onClick={
                            (["Make a Portfolio", "Make an Account", "Login to platform 10 times in a month","Join Our TG Channel", "Join Twitter"].includes(data.action) && data.status === "Complete")
                                ? undefined
                                : () => handleClick(data)
                        }
                    >
                               {getButtonLabel(data)}
                             </button>
                             </div>
                             </div>
                             )
                             
                             )}
           {loading && (
              <div style={{ textAlign: "center", margin: "20px" }}>
                <div className="loader"></div> {/* add a simple CSS spinner */}
              </div>
            )}
            <style>
         {`
          
             .loader {
            border: 4px solid rgba(24, 119, 242, 0.3);
            border-top: 4px solid #1877F2;
            border-radius: 50%;
            width: 35px;
            height: 35px;
            animation: spin 0.8s linear infinite;
            margin:auto;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

         `}
       </style>
          </div>          
        )}





                        {/* <table
                            className="predictions-table-mobile"
                            style={{
                                width: "100%",
                                borderCollapse: "separate",
                                borderSpacing: "0 10px",
                                marginBottom: "80px",
                            }}
                        >
                            <tbody>
                                {dataCompleted && !rewards?.length ? (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            style={{
                                                textAlign: "center",
                                                padding: "20px",
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                color: "#76787A",
                                            }}
                                        >
                                            No Reward Transaction Available
                                        </td>
                                    </tr>
                                ) : (
                                    rewards?.map((data, index) => (
                                        <tr
                                            key={index}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                borderRadius: "10px",
                                                marginBottom: "20px",
                                                padding: "0px",
                                                height: "100px",
                                            }}
                                        >
                                            <td
                                                style={{
                                                    background:
                                                        "linear-gradient(91deg, #9AFFF9 18.86%, #FFF06D 100.02%)",
                                                    borderRadius: "6px 6px 0px 0px",
                                                    padding: "10px",
                                                    fontWeight: "500",
                                                    fontSize: "20px",
                                                    color: "#000",
                                                }}
                                            >
                                                {data.action}
                                            </td>

                                            <td style={{padding: "4px 10px", fontSize: "14px"}}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    <div>
                                                        <span
                                                            style={{
                                                                color: "#76787A",
                                                                fontSize: "16px",
                                                                marginRight: "7px",
                                                            }}
                                                        >
                                                            Reward Token :
                                                        </span>{" "}
                                                        {data.reward_tokens}
                                                    </div>
                                                    <div>
                                                        <span
                                                            style={{
                                                                color: "#76787A",
                                                                fontSize: "16px",
                                                                marginRight: "7px",
                                                            }}
                                                        >
                                                            Date :
                                                        </span>{" "}
                                                        {data.created_at
                                                            ? new Date(data.created_at).toLocaleDateString()
                                                            : "N/A"}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                <tr ref={lastRowRef} style={{visibility: "hidden"}}></tr>
                            </tbody>
                            {loading && !dataCompleted && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "20px 0",
                                    }}
                                >
                                    <CircularProgress />
                                </div>
                            )}
                        </table> */}
                    </div>

                    <div
                        style={{
                            position: "fixed",
                            bottom: "0",
                            background: "#F1F1F1",
                            height: "10px",
                            zIndex: 200,
                            width: "100%",
                        }}
                    />
                    <div
                        style={{
                            position: "fixed",
                            bottom: "0",
                            backgroundColor: "white",
                            width: "105%",
                            zIndex: "100",
                            marginBottom: "0px",
                            marginLeft: "-25px",
                        }}
                    >
                        <BottomNavigation showLabels>
                            <BottomNavigationAction
                                label="Top Portfolios"
                                onClick={() => navigate("/portfolio-gallery")}
                                icon={
                                    <img
                                        src={getIcon(
                                            "/portfolio-gallery",
                                            "/images/dashboardS.svg",
                                            "/images/dashboardU.svg"
                                        )}
                                        width={"20px"}
                                        height={"20px"}
                                        alt="Top Portfolios"
                                    />
                                }
                            />
                            <BottomNavigationAction
                                label="Crypto Screener"
                                onClick={() => navigate("/crypto-screener")}
                                icon={
                                    <img
                                        src={getIcon(
                                            "/crypto-screener",
                                            "/images/portfolioS.svg",
                                            "/images/portfolioU.svg"
                                        )}
                                        width={"20px"}
                                        height={"20px"}
                                        alt="Crypto Screener"
                                    />
                                }
                            />
                            <BottomNavigationAction
                                label="$1/Month Subscription"
                                onClick={handleSubscriptionClick}
                                icon={
                                    <img
                                        src={getIcon(
                                            "/subscriptions",
                                            "/images/dollarS.svg",
                                            "/images/dollarU.svg"
                                        )}
                                        width={24}
                                        height={24}
                                        alt="Subscription"
                                        style={{marginBottom: "-3px"}}
                                    />
                                }
                            />
                        </BottomNavigation>
                    </div>
                </>
            )}

            {isLoginModalOpen && (
                <LoginPopUp
                    isLoginModalOpen={isLoginModalOpen}
                    setLoginModalOpen={setLoginModalOpen}
                    onClose={handleModalClose}
                />
            )}
        </div>
    );
};

export default RewardSection;
